import { InputNumberInteger } from "./InputNumber";

export const InputNumberMinMax = ({
  minField,
  minId,
  minElementClass,
  minLabel = "Min",
  maxField,
  maxId,
  maxLabel = "Max",
  elementClass,
  maxElementClass,
  decimalScale = 0,
  allowNegative = false,
  fixedDecimalScale = true,
  showLabel = true,
  disabled = false,
  suffix = "",
  ...props
}: any) => {
  const commonProps = { decimalScale, allowNegative, showLabel, disabled, suffix };
  return (
    <div className={elementClass}>
      <InputNumberInteger
        {...{ id: minId, elementClass: minElementClass, label: minLabel, ...commonProps }}
      />
      <InputNumberInteger
        {...{ id: maxId, elementClass: maxElementClass, label: maxLabel, ...commonProps }}
      />
    </div>
  );
};
